const INITIAL_STATE = {
    status: 'done',
    message: null,
}

export default (state = INITIAL_STATE, action) => {
    
    switch (action.type) {
        case 'SIGNUP_CHANGED_STATUS':
            return { ...state, status: action.payload.status, message: action.payload.message }        
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/modules/reducers/signupReducer.js